export default __webpack_public_path__ + "static/media/img-cube3.13d9296f.svg";